export default class FuncionaAnaliticaController {
    constructor($state, $timeout, $filter, UIService, AuthorizationService, AuthenticationService, FunProcesso, FunTecnico, FunLote) {
        this.$state = $state;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.UI = UIService;
        this.AuthorizationService = AuthorizationService;
        this.user = AuthenticationService.getUser();
        this.FunProcesso = FunProcesso;
        this.FunTecnico = FunTecnico;
        this.FunLote = FunLote;
        this.daily = {
            loaded: false,
            data: null
        };
        this.weekly = {
            loaded: false,
            show: {
                processos: true,
                pagamentos: false
            },
            data: null
        };
        this.monthly = {
            loaded: false,
            show: {
                processos: true,
                pagamentos: false
            },
            data: null
        };
        this.yearly = {
            loaded: false,
            show: {
                processos: true,
                pagamentos: false
            },
            data: null
        };
        this.total = {
            loaded: false,
            show: {
                processos: true,
                pagamentos: false,
            },
            data: null
        };
        // Global data so we don't have to refetch them all the time
        this.lotes = null;
        this.tecnicos = null;
        let now = moment();
        // To prevent reloading everything for faulty ng-change
        this.previousMonthly = now.clone();
        this.previousYearly = now.clone();
        this.minDatePicker = moment('2023-01-06T00:00:00+01:00');
        this.dateOptions = {
            monthly: { format: 'MM/YYYY', minDate: this.minDatePicker, maxDate: now },
            yearly: { format: 'YYYY', minDate: this.minDatePicker, maxDate: now }
        };
        // Date time pickers for month, year
        this.monthlyPicker = now.clone();
        this.yearlyPicker = now.clone();
        // Loaders for Stats Funciona
        this.getFuncionaStats();
    }
    ;
    showFuncionaChart = (period, type) => {
        this[period].show.processos = false;
        this[period].show.pagamentos = false;
        this[period].show[type] = true;
    };
    // Returns the maximum of the stacked sums of the array of arrays (used for the stacked chart)
    getMaxStacked = (data) => Math.max(...data[0].map((_, colIndex) => data.reduce((sum, row) => sum + row[colIndex], 0)));
    getStats = (data) => {
        return {
            agendados: data.reduce((sum, item) => sum + item.agendados, 0),
            realizados: data.reduce((sum, item) => sum + item.realizados, 0),
            nRealizados: data.reduce((sum, item) => sum + item.nRealizados, 0),
            pendentes: data.reduce((sum, item) => sum + item.pendentes, 0),
            valorTotal: data.reduce((sum, item) => sum + item.valorTotal, 0),
            valorRealizado: data.reduce((sum, item) => sum + item.valorRealizado, 0),
            valorNRealizado: data.reduce((sum, item) => sum + item.valorNRealizado, 0),
            valorPendente: data.reduce((sum, item) => sum + item.valorPendente, 0)
        };
    };
    getHeatmapClass = (count) => {
        if (count === 0)
            return 'bg-zero';
        if (count < 8)
            return 'bg-low';
        if (count <= 10)
            return 'bg-medium';
        if (count > 10)
            return 'bg-high';
        return "";
    };
    getFuncionaStats = () => {
        this.funcionaStatsTabs = [{
                cId: 'daily',
                name: 'Hoje',
            }, {
                cId: 'weekly',
                name: 'Semanal',
            }, {
                cId: 'monthly',
                name: 'Mensal'
            }, {
                cId: 'yearly',
                name: 'Anual'
            }, {
                cId: 'total',
                name: 'Total'
            }];
        // Find Lotes for stats
        this.FunLote.find({
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise.then((lotes) => {
            lotes.sort((a, b) => a.distrito.localeCompare(b.distrito));
            this.lotes = lotes;
            // Find tecnicos for stats
            this.FunTecnico.find({
                fields: { id: true, active: true, funcionarioId: true },
                filter: {
                    where: {
                    // Nothing for now, get them all because it may be relevant to see old information
                    },
                    include: {
                        relation: 'funcionario',
                        scope: {
                            fields: { name: true }
                        }
                    }
                },
            }).$promise.then((tecnicos) => {
                tecnicos = tecnicos.map(x => {
                    return { id: x.funcionarioId, active: x.active, name: x.funcionario.name };
                });
                tecnicos.sort((a, b) => a.name.localeCompare(b.name));
                this.tecnicos = tecnicos;
                // Processos (Diário)
                this.FunProcesso.getAnalitica({ params: { type: 'day', tecnicos: tecnicos, lotes: lotes } }).$promise.then((data) => {
                    this.daily.data = data.processos;
                    this.daily.oldData = data.oldProcessos;
                    this.daily.dataTecnicos = data.tecnicos;
                    this.daily.dataLotes = data.lotes;
                    this.daily.loaded = true;
                }).catch(error => {
                    console.log(error);
                    this.UI.addToast("Erro na obtenção de dados de analítica de processos. Verifique a ligação");
                    this.$state.go('app.dashboard');
                });
                // Processos (Semanal)
                this.FunProcesso.getAnalitica({ params: { type: 'week', tecnicos: tecnicos, lotes: lotes } }).$promise.then((data) => {
                    this.weekly.stats = this.getStats(data.processos.data);
                    this.weekly.oldStats = this.getStats(data.oldProcessos.data);
                    this.weekly.data = data.processos;
                    this.weekly.chartProcessos = this.createChart(data.processos, 'weekly', 'Processos');
                    this.weekly.chartPagamentos = this.createChart(data.processos, 'weekly', 'Pagamentos');
                    this.weekly.chartLineProcessos = this.createLineChart(data, 'weekly', 'Processos');
                    this.weekly.chartLineProcessosPagamentos = this.createLineChart(data, 'weekly', 'Pagamentos');
                    this.weekly.dataTecnicos = data.tecnicos;
                    this.weekly.chartTecnicos = this.createChart(data.tecnicos, 'weekly', 'Processos', true);
                    this.weekly.chartTecnicosPagamentos = this.createChart(data.tecnicos, 'weekly', 'Pagamentos', true);
                    this.weekly.dataLotes = data.lotes;
                    this.weekly.chartLotes = this.createChart(data.lotes, 'weekly', 'Processos');
                    this.weekly.chartLotesPagamentos = this.createChart(data.lotes, 'weekly', 'Pagamentos');
                    this.weekly.chartProdutividade = this.createProdutividadeChart(data.produtividade);
                    this.weekly.loaded = true;
                }).catch(error => {
                    console.log(error);
                    this.UI.addToast("Erro na obtenção de dados de analítica de processos. Verifique a ligação");
                    this.$state.go('app.dashboard');
                });
                // Processos (Mensal)
                this.FunProcesso.getAnalitica({ params: { type: 'month', tecnicos: tecnicos, lotes: lotes } }).$promise.then((data) => {
                    this.monthly.stats = this.getStats(data.processos.data);
                    this.monthly.oldStats = this.getStats(data.oldProcessos.data);
                    this.monthly.data = data.processos;
                    this.monthly.dataTecnicos = data.tecnicos;
                    this.monthly.chartProcessos = this.createChart(data.processos, 'monthly', 'Processos');
                    this.monthly.chartPagamentos = this.createChart(data.processos, 'monthly', 'Pagamentos');
                    this.monthly.chartLineProcessos = this.createLineChart(data, 'monthly', 'Processos');
                    this.monthly.chartLineProcessosPagamentos = this.createLineChart(data, 'monthly', 'Pagamentos');
                    this.monthly.dataTecnicos = data.tecnicos;
                    this.monthly.chartTecnicos = this.createChart(data.tecnicos, 'monthly', 'Processos', true);
                    this.monthly.chartTecnicosPagamentos = this.createChart(data.tecnicos, 'monthly', 'Pagamentos', true);
                    this.monthly.dataLotes = data.lotes;
                    this.monthly.chartLotes = this.createChart(data.lotes, 'monthly', 'Processos');
                    this.monthly.chartLotesPagamentos = this.createChart(data.lotes, 'monthly', 'Pagamentos');
                    this.monthly.dataHeatmap = data.tecnicosHeatmap; // Heatmap data
                    this.monthly.chartProdutividade = this.createProdutividadeChart(data.produtividade);
                    this.monthly.loaded = true;
                }).catch(error => {
                    console.log(error);
                    this.UI.addToast("Erro na obtenção de dados de analítica de processos. Verifique a ligação");
                    this.$state.go('app.dashboard');
                });
                // Processos (Anual)
                this.FunProcesso.getAnalitica({ params: { type: 'year', tecnicos: tecnicos, lotes: lotes } }).$promise.then((data) => {
                    this.yearly.stats = this.getStats(data.processos.data);
                    this.yearly.oldStats = this.getStats(data.oldProcessos.data);
                    this.yearly.data = data.processos;
                    this.yearly.dataTecnicos = data.tecnicos;
                    this.yearly.chartProcessos = this.createChart(data.processos, 'yearly', 'Processos');
                    this.yearly.chartPagamentos = this.createChart(data.processos, 'yearly', 'Pagamentos');
                    this.yearly.chartLineProcessos = this.createLineChart(data, 'yearly', 'Processos');
                    this.yearly.chartLineProcessosPagamentos = this.createLineChart(data, 'yearly', 'Pagamentos');
                    this.yearly.dataTecnicos = data.tecnicos;
                    this.yearly.chartTecnicos = this.createChart(data.tecnicos, 'yearly', 'Processos', true);
                    this.yearly.chartTecnicosPagamentos = this.createChart(data.tecnicos, 'yearly', 'Pagamentos', true);
                    this.yearly.dataLotes = data.lotes;
                    this.yearly.chartLotes = this.createChart(data.lotes, 'yearly', 'Processos');
                    this.yearly.chartLotesPagamentos = this.createChart(data.lotes, 'yearly', 'Pagamentos');
                    this.yearly.chartProdutividade = this.createProdutividadeChart(data.produtividade);
                    this.yearly.loaded = true;
                }).catch(error => {
                    console.log(error);
                    this.UI.addToast("Erro na obtenção de dados de analítica de processos. Verifique a ligação");
                    this.$state.go('app.dashboard');
                });
                // Processos (Total)
                this.FunProcesso.getAnalitica({ params: { type: 'total', tecnicos: tecnicos, lotes: lotes } }).$promise.then((data) => {
                    this.total.data = data.processos;
                    this.total.dataTecnicos = data.tecnicos;
                    this.total.loaded = true;
                }).catch(error => {
                    console.log(error);
                    this.UI.addToast("Erro na obtenção de dados de analítica de processos. Verifique a ligação");
                    this.$state.go('app.dashboard');
                });
            }).catch((error) => {
                console.log(error);
                this.UI.addToast("Não foi possível carregar técnicos para analítica. Recarregue a página");
            });
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Não foi possível carregar lotes para analítica. Recarregue a página");
        });
    };
    extractAttributes = (data, attributes) => attributes.map(attr => data.map(item => item[attr] || 0));
    // For display only
    getReadablePeriod = (period) => {
        switch (period) {
            // Daily not used in this context
            case 'weekly': return 'Semana';
            case 'monthly': return 'Mês';
            case 'yearly': return 'Ano';
            default: return 'Período';
        }
    };
    // For display only
    getReadableType = (showObject) => {
        if (!showObject)
            return '';
        if (showObject.processos)
            return "Processos";
        if (showObject.pagamentos)
            return "Pagamentos";
        return '';
    };
    /*
     * Params:
     * data         - Data to generate chart
     * period       - Type of chart to display ('weekly','monthly','yearly')
     * type         - Datatype (Processos, Pagamentos)
     * isHorizontal - true if it's horizontal chart (for labels not to be pushed down)
     * */
    createChart = (data, period, type, isHorizontal) => {
        let filter = this.$filter;
        // Colors for chart processos
        let colors, series, seriesLabels;
        switch (type) {
            case 'Processos':
                colors = [
                    { backgroundColor: "#388e3c", borderColor: 'transparent', borderWidth: 0 }, // Realizados
                    { backgroundColor: "#AA3033", borderColor: 'transparent', borderWidth: 0 }, // NRealizados
                    { backgroundColor: "#FDA50F", borderColor: 'transparent', borderWidth: 0 } // Pendentes
                ];
                series = ['realizados', 'nRealizados', 'pendentes']; // Fields that come in the objects from data.data
                seriesLabels = ['Realizados', 'Não Realizados', 'Pendentes'];
                break;
            case 'Pagamentos':
                colors = [
                    { backgroundColor: "#388e3c", borderColor: 'transparent', borderWidth: 0 }, // Realizados
                    { backgroundColor: "#AA3033", borderColor: 'transparent', borderWidth: 0 }, // NRealizados
                    { backgroundColor: "#FDA50F", borderColor: 'transparent', borderWidth: 0 } // Pendentes
                ];
                series = ['valorRealizado', 'valorNRealizado', 'valorPendente']; // Fields that come in the objects from data.data
                seriesLabels = ['Valor Realizado', 'Valor Não Realizado', 'Valor Pendente'];
                break;
        }
        // Array of arrays with the data for series
        let chartData = this.extractAttributes(data.data, series);
        let totals = this.extractAttributes(data.data, ['agendados', 'valorTotal']);
        // Get max for scale purposes
        let subdivisions = 5;
        let max = this.getMaxStacked(chartData);
        let maxScale = max + (subdivisions - max % subdivisions);
        let step = maxScale / subdivisions;
        //Create chart object
        return {
            colors: colors,
            series: seriesLabels,
            labels: data.labels,
            data: chartData,
            totals: totals,
            options: {
                legend: {
                    display: true,
                    position: 'top'
                },
                layout: {
                    padding: {
                        top: 24,
                        right: 0,
                        left: 0,
                        bottom: 0
                    }
                },
                tooltips: {
                    enabled: true
                },
                hover: {
                    animationDuration: 1
                },
                animation: {
                    duration: 1,
                    onComplete: function () {
                        let chartInstance = this.chart, ctx = chartInstance.ctx;
                        ctx.textAlign = 'center';
                        ctx.fillStyle = "rgba(0, 0, 0, 1)";
                        ctx.textBaseline = 'bottom';
                        if (period !== 'monthly' || type !== 'Pagamentos') { // Data too large to see
                            this.data.datasets.forEach(function (dataset, i) {
                                let meta = chartInstance.controller.getDatasetMeta(i);
                                if (meta.hidden)
                                    return; // Do nothing if it's hidden
                                meta.data.forEach(function (bar, index) {
                                    let data = dataset.data[index];
                                    if (data !== 0) { // Only show data that is not 0
                                        if (type === 'Pagamentos') {
                                            data = filter('currency')(data, '€', 2);
                                        }
                                        if (!isHorizontal)
                                            ctx.fillText(data, bar._model.x, bar._model.y + 15);
                                        else
                                            ctx.fillText(data, bar._model.x, bar._model.y);
                                    }
                                });
                            });
                        }
                    }
                },
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                            stacked: true,
                            ticks: {
                                beginAtZero: true,
                                stepSize: step,
                                suggestedMax: maxScale,
                            },
                            gridLines: {
                                drawBorder: true,
                                display: true
                            }
                        }],
                    xAxes: [{
                            stacked: true,
                            gridLines: {
                                drawBorder: true,
                                display: false
                            }
                        }]
                }
            },
        };
    };
    createLineChart = (data, period, type) => {
        let filter = this.$filter;
        const labels = data.processos.labels;
        let previous, current;
        switch (type) {
            case 'Processos':
                previous = data.oldProcessos.data.map(d => d.realizados ? d.realizados : null);
                current = data.processos.data.map(d => d.realizados ? d.realizados : null);
                break;
            case 'Pagamentos':
                previous = data.oldProcessos.data.map(d => d.valorRealizado ? d.valorRealizado : null);
                current = data.processos.data.map(d => d.valorRealizado ? d.valorRealizado : null);
                break;
        }
        const maxValue = Math.max(...current.concat(previous)); // Use both series
        const buffer = Math.ceil(maxValue * 0.1); // Add 10% headroom
        return {
            labels: labels,
            series: [`${this.getReadablePeriod(period)} Anterior`, `${this.getReadablePeriod(period)} Atual`],
            data: [previous, current],
            colors: [
                {
                    borderColor: '#AAAAAA',
                    backgroundColor: 'rgba(170, 170, 170, 1)',
                    pointBackgroundColor: '#AAAAAA',
                    fill: false
                },
                {
                    borderColor: '#000',
                    backgroundColor: 'rgba(0, 0, 0, 1)',
                    pointBackgroundColor: '#000',
                    fill: false
                }
            ],
            options: {
                legend: {
                    display: true,
                    position: 'top'
                },
                tooltips: {
                    enabled: true
                },
                layout: {
                    padding: {
                        top: 40,
                        right: 0,
                        left: 0,
                        bottom: 0
                    }
                },
                maintainAspectRatio: false,
                animation: {
                    duration: 1,
                    onComplete: function () {
                        const chartInstance = this.chart;
                        const ctx = chartInstance.ctx;
                        ctx.font = 'bold 12px Arial';
                        ctx.fillStyle = 'rgba(0, 0, 0, 1)';
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'bottom';
                        this.data.datasets.forEach(function (dataset, i) {
                            const meta = chartInstance.controller.getDatasetMeta(i);
                            if (meta.hidden || i === 0)
                                return;
                            meta.data.forEach(function (point, index) {
                                let value = dataset.data[index];
                                if (value !== 0 && value !== null && value !== undefined && type !== 'Pagamentos') {
                                    ctx.fillText(value, point._model.x, point._model.y - 10);
                                }
                            });
                        });
                    }
                },
                elements: {
                    line: {
                        tension: 0 // makes lines straight
                    }
                },
                scales: {
                    yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                suggestedMax: maxValue + buffer,
                                callback: function (value) {
                                    if (type === 'Pagamentos') {
                                        return filter('currency')(value, '€', 0);
                                    }
                                    if (!isNaN(value))
                                        return Math.round((value + Number.EPSILON) * Math.pow(10, 2)) / Math.pow(10, 2); // Show at most ..,XX
                                    return value;
                                }
                            },
                            gridLines: {
                                drawBorder: true,
                                display: true
                            }
                        }],
                    xAxes: [{
                            gridLines: {
                                drawBorder: true,
                                display: false
                            }
                        }]
                }
            }
        };
    };
    createProdutividadeChart = (data) => {
        let filter = this.$filter;
        // Colors for chart processos
        const colors = [
            { backgroundColor: "#049a9b", borderColor: 'transparent', borderWidth: 0 }, // Produtividade
        ];
        const series = ['Índice de Produtividade']; // Fields that come in the objects from data.data
        const seriesLabels = data.labels || [];
        const chartData = data.data || [];
        // Get max for scale purposes
        let subdivisions = 5;
        // Fixed for this specific chart
        // let max = 14; // Fixed because it can't go much higher
        // let maxScale = max + (subdivisions - max % subdivisions);
        // let step = maxScale / subdivisions;
        let maxScale = 14;
        let step = 1;
        //Create chart object
        return {
            colors: colors,
            series: series,
            labels: seriesLabels,
            data: [chartData],
            options: {
                legend: {
                    display: true,
                    position: 'top'
                },
                layout: {
                    padding: {
                        top: 24,
                        right: 0,
                        left: 0,
                        bottom: 0
                    }
                },
                tooltips: {
                    enabled: true
                },
                hover: {
                    animationDuration: 1
                },
                animation: {
                    duration: 1,
                    onComplete: function () {
                        let chartInstance = this.chart, ctx = chartInstance.ctx;
                        ctx.textAlign = 'center';
                        ctx.fillStyle = "rgba(0, 0, 0, 1)";
                        ctx.textBaseline = 'bottom';
                        this.data.datasets.forEach(function (dataset, i) {
                            let meta = chartInstance.controller.getDatasetMeta(i);
                            if (meta.hidden)
                                return; // Do nothing if it's hidden
                            meta.data.forEach(function (bar, index) {
                                let data = filter('number')(dataset.data[index], 2);
                                if (data !== 0) { // Only show data that is not 0
                                    ctx.fillText(data, bar._model.x + 15, bar._model.y + 5);
                                }
                            });
                        });
                    }
                },
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                            stacked: true,
                            gridLines: {
                                drawBorder: true,
                                display: true
                            }
                        }],
                    xAxes: [{
                            stacked: true,
                            ticks: {
                                beginAtZero: true,
                                stepSize: step,
                                suggestedMax: maxScale,
                            },
                            gridLines: {
                                drawBorder: true,
                                display: false
                            }
                        }]
                }
            },
        };
    };
    // Functions called when changing the date picker
    onDateUpdate = (period) => {
        if (period === 'monthly') {
            if (this.monthlyPicker.isSame(this.previousMonthly, 'day'))
                return;
            this.previousMonthly = this.monthlyPicker.clone();
            this.monthly.loaded = false;
            // Processos (Mensal)
            this.FunProcesso.getAnalitica({
                params: {
                    type: 'month',
                    tecnicos: this.tecnicos,
                    lotes: this.lotes,
                    period: this.monthlyPicker.format()
                }
            }).$promise.then((data) => {
                this.monthly.stats = this.getStats(data.processos.data);
                this.monthly.oldStats = this.getStats(data.oldProcessos.data);
                this.monthly.data = data.processos;
                this.monthly.dataTecnicos = data.tecnicos;
                this.monthly.chartProcessos = this.createChart(data.processos, 'monthly', 'Processos');
                this.monthly.chartPagamentos = this.createChart(data.processos, 'monthly', 'Pagamentos');
                this.monthly.chartLineProcessos = this.createLineChart(data, 'monthly', 'Processos');
                this.monthly.chartLineProcessosPagamentos = this.createLineChart(data, 'monthly', 'Pagamentos');
                this.monthly.dataTecnicos = data.tecnicos;
                this.monthly.chartTecnicos = this.createChart(data.tecnicos, 'monthly', 'Processos', true);
                this.monthly.chartTecnicosPagamentos = this.createChart(data.tecnicos, 'monthly', 'Pagamentos', true);
                this.monthly.dataLotes = data.lotes;
                this.monthly.chartLotes = this.createChart(data.lotes, 'monthly', 'Processos');
                this.monthly.chartLotesPagamentos = this.createChart(data.lotes, 'monthly', 'Pagamentos');
                this.monthly.dataHeatmap = data.tecnicosHeatmap; // Heatmap data
                this.monthly.loaded = true;
            }).catch(error => {
                console.log(error);
                this.UI.addToast("Erro na obtenção de dados de analítica de processos. Verifique a ligação");
                this.$state.go('app.dashboard');
            });
        }
        if (period === 'yearly') {
            if (this.yearlyPicker.isSame(this.previousYearly, 'day'))
                return;
            this.previousYearly = this.yearlyPicker.clone();
            this.yearly.loaded = false;
            // Processos (Anual)
            this.FunProcesso.getAnalitica({
                params: {
                    type: 'year',
                    tecnicos: this.tecnicos,
                    lotes: this.lotes,
                    period: this.yearlyPicker.format()
                }
            }).$promise.then((data) => {
                this.yearly.stats = this.getStats(data.processos.data);
                this.yearly.oldStats = this.getStats(data.oldProcessos.data);
                this.yearly.data = data.processos;
                this.yearly.dataTecnicos = data.tecnicos;
                this.yearly.chartProcessos = this.createChart(data.processos, 'yearly', 'Processos');
                this.yearly.chartPagamentos = this.createChart(data.processos, 'yearly', 'Pagamentos');
                this.yearly.chartLineProcessos = this.createLineChart(data, 'yearly', 'Processos');
                this.yearly.chartLineProcessosPagamentos = this.createLineChart(data, 'yearly', 'Pagamentos');
                this.yearly.dataTecnicos = data.tecnicos;
                this.yearly.chartTecnicos = this.createChart(data.tecnicos, 'yearly', 'Processos', true);
                this.yearly.chartTecnicosPagamentos = this.createChart(data.tecnicos, 'yearly', 'Pagamentos', true);
                this.yearly.dataLotes = data.lotes;
                this.yearly.chartLotes = this.createChart(data.lotes, 'yearly', 'Processos');
                this.yearly.chartLotesPagamentos = this.createChart(data.lotes, 'yearly', 'Pagamentos');
                this.yearly.loaded = true;
            }).catch(error => {
                console.log(error);
                this.UI.addToast("Erro na obtenção de dados de analítica de processos. Verifique a ligação");
                this.$state.go('app.dashboard');
            });
        }
    };
}
FuncionaAnaliticaController.$inject = ['$state', '$timeout', '$filter', 'UIService', 'AuthorizationService', 'AuthenticationService', 'FunProcesso', 'FunTecnico', 'FunLote'];
